const trainRoutes = [
    {
        path:'index',
        name:'train-index',
        component: () => import(/* webpackChunkName: "about" */ '@/views/train/index.vue')
    },
    {
        path:'targetSetting',
        name:'train-targetSetting',
        component: () => import(/* webpackChunkName: "about" */ '@/views/train/targetSetting.vue')
    },
    
  ]
  export default trainRoutes